import React, { Component, forwardRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Button,
  MenuItem,
  withStyles,
  Paper,
  MenuList,
  Popper,
  ClickAwayListener,
  Grow,
  Grid,
  IconButton,
  Tooltip,
} from '@material-ui/core'
import { ArrowLeft, ArrowRight, PersonOutline } from '@material-ui/icons'
import { Refresh, SortAscending, SortDescending } from 'mdi-material-ui'
import { changeSort } from 'actions/tasks'
import {
  changeSortBy,
  changeSortOrder,
  selectUserAssignment,
  forceListUpdate,
} from 'actions/view'
import ToggleViewButton from './ToggleViewButton'
import language from 'utils/vast-languagepack'
import Search from './Search'
import { startCase, capitalize } from 'lodash'
import { list } from 'actions/data'
import Tag from './Tag'
import { DATA_API_URL } from 'utils/AllURLs'

const ContactMenu = connect(
  state => ({
    users: Object.values(state.data['account/user'] || {}),
    currentUser: state?.auth?.session?.idToken?.payload?.['cognito:username'],
    userAssignment: state?.sort?.userAssignment,
    assignmentPoolsLength: Object.values(state.data?.['account/ap'] || {})
      ?.length,
  }),
  dispatch => bindActionCreators({ list, selectUserAssignment }, dispatch),
)(
  class ContactMenuComponent extends Component {
    state = { open: false }

    componentDidMount() {
      if (!this.props.users.length) {
        this.props.list('account/user', 'user_name')
      }

      if (this.props.assignmentPoolsLength) {
        this.props.list('contact/a2', null, null, null, true, true)
      } else {
        this.props
          .list('account/ap')
          .then(() =>
            this.props.list('contact/a2', null, null, null, true, true),
          )
      }
    }

    handleToggle = () => {
      this.setState(state => ({ open: !state.open }))
    }

    handleClose = endpoint => event => {
      if (this.anchorEl.contains(event.target)) {
        return
      }
      this.setState({ open: false })
      if (endpoint) {
        this.props.list(endpoint, null, null, null, true, true).then(() => {
          this.props.selectUserAssignment(endpoint)
        })
      }
    }

    render() {
      const { open } = this.state

      return (
        <>
          <IconButton
            onClick={this.handleToggle}
            style={{ color: '#fff', padding: 6 }}
            buttonRef={node => {
              this.anchorEl = node
            }}
            aria-owns={open ? 'user-menu-list-grow' : undefined}
            aria-haspopup="true"
          >
            <PersonOutline />
          </IconButton>
          <Popper
            open={open}
            anchorEl={this.anchorEl}
            transition
            disablePortal
            style={{ zIndex: 1 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="user-menu-list-grow"
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={this.handleClose()}>
                    <MenuList>
                      <MenuItem
                        selected={!this.props.userAssignment}
                        onClick={this.handleClose()}
                      >
                        All contacts
                      </MenuItem>
                      <MenuItem
                        selected={this.props.userAssignment === 'contact/a2'}
                        onClick={this.handleClose('contact/a2')}
                      >
                        Unassigned contacts
                      </MenuItem>
                      {this.props.users.map(user => (
                        <MenuItem
                          selected={
                            this.props.userAssignment ===
                            `contact/a2/${user?.user_name}`
                          }
                          onClick={this.handleClose(
                            `contact/a2/${user?.user_name}`,
                          )}
                          key={`listUserAssignmentMenuOption${user?.user_name}`}
                        >
                          {user?.user_name === this.props.currentUser
                            ? 'My contacts'
                            : `${user?.first_name || ''} ${
                                user?.last_name || ''
                              } Contacts`}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </>
      )
    }
  },
)

// this needs to only show the contact button if it's on the contacts page

const SortMenu = connect(
  state => ({ search: state.search }),
  (dispatch, { listFn }) =>
    bindActionCreators(
      listFn
        ? {
            ...listFn,
            changeSort,
            changeSortBy,
            changeSortOrder,
            forceListUpdate,
          }
        : { list, changeSort, changeSortBy, changeSortOrder, forceListUpdate },
      dispatch,
    ),
)(
  class SortMenuComponent extends Component {
    state = {
      open: false,
    }

    handleToggle = () => {
      this.setState(state => ({ open: !state.open }))
    }

    handleClose = sortOrder => event => {
      if (this.anchorEl.contains(event.target)) {
        return
      }
      this.setState({ open: false })
      if (sortOrder) this.props.changeSortBy(this.props.endpoint, sortOrder)
    }

    render() {
      const { search, sort, endpoint, changeSortOrder, keys } = this.props
      const { open } = this.state
      return (
        <div>
          <Grid container justify="space-between">
            <Grid item></Grid>
            <Grid item>
              {/* <div style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
                Total:
              </div> */}
              {endpoint !== 'contact' && typeof search !== 'string' && (
                <Tooltip title="Refresh">
                  <IconButton
                    style={{ color: '#fff', padding: 6, marginRight: 5 }}
                    onClick={() => {
                      if (this.props.listFn) {
                        Object.keys(this.props.listFn).forEach(fn =>
                          this.props[fn](),
                          this.props.forceListUpdate()
                        )
                      } else {
                        this.props
                          .list(this.props.endpoint)
                          .then(() => {
                            this.props.list(
                              'userpin',
                              null,
                              `${DATA_API_URL}/userpin/username-entity?secondary_id=${this.props.endpoint}`,
                            )
                            .then(() => {
                              this.props.forceListUpdate()
                            })
                          })
                      }
                    }}
                  >
                    <Refresh />
                  </IconButton>
                </Tooltip>
              )}
              <Search
                sort={endpoint}
                keys={keys}
                nonSortableKeys={this.props.nonSortableKeys}
              />
              <Tooltip title="Switch sort order">
                <IconButton
                  style={{ color: '#fff', padding: 6 }}
                  onClick={() => changeSortOrder(endpoint)}
                >
                  {sort && sort.order === 'desc' ? (
                    <SortDescending />
                  ) : (
                    <SortAscending />
                  )}
                </IconButton>
              </Tooltip>
              <Button
                buttonRef={node => {
                  this.anchorEl = node
                }}
                aria-owns={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={this.handleToggle}
                style={{ color: '#fff' }}
              >
                {/* <SortIcon className={classes.leftIcon} /> */}
                {language.task.menuSort.sort}
              </Button>
              {endpoint === 'contact' ? <ContactMenu /> : null}
            </Grid>
          </Grid>
          <Popper
            open={open}
            anchorEl={this.anchorEl}
            transition
            disablePortal
            style={{ zIndex: 1 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="menu-list-grow"
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={this.handleClose()}>
                    <MenuList>
                      {keys.map((key, idx) => (
                        <MenuItem
                          selected={sort.sortBy === key}
                          key={`listSortMenuOption${idx}`}
                          onClick={this.handleClose(key)}
                        >
                          {capitalize(startCase(key))}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      )
    }
  },
)

class SortComponent extends Component {
  state = { date: '' }

  componentDidUpdate(prevProps) {
    if (prevProps.schedulerMounted !== this.props.schedulerMounted) {
      if (this.props.schedulerMounted) {
        const dateString =
          this.props.forwardedRef &&
          this.props.forwardedRef.current &&
          this.props.forwardedRef.current.getApi &&
          this.props.forwardedRef.current.getApi().getDate &&
          this.props.forwardedRef.current.getApi().getDate().toDateString &&
          this.props.forwardedRef.current.getApi().getDate().toDateString()

        if (typeof dateString === 'string') {
          this.setState({
            date: `${dateString.slice(4, 7)} ${dateString.slice(11)}`,
          })
        }
      }
    }
  }

  render() {
    const {
      classes,
      campaignPage,
      forwardedRef,
      viewSelected,
      schedulerMounted,
      calendarView,
      sort,
      endpoint,
      sortableKeys,
      nonSortableKeys,
      listFn,
    } = this.props

    const component = (
      <Paper className={classes.sort}>
        <Grid container justify="space-between">
          <Grid item>
            <Grid container>
              <Grid item>
                {calendarView ? (
                  campaignPage ? (
                    <ToggleViewButton campaignPage icon />
                  ) : (
                    <ToggleViewButton icon />
                  )
                ) : null}
                {endpoint === 'contact' && <Tag />}
              </Grid>
              {viewSelected === 'calendar' ? (
                <Grid item>
                  <Grid container>
                    <Grid item>
                      <Button
                        size="small"
                        style={{
                          color: '#fff',
                          minWidth: 0,
                          padding: '6px 8px',
                        }}
                        onClick={() =>
                          Promise.resolve(
                            forwardedRef &&
                              forwardedRef.current &&
                              forwardedRef.current.getApi &&
                              forwardedRef.current.getApi().today(),
                          ).then(() => {
                            const dateString =
                              this.props.forwardedRef &&
                              this.props.forwardedRef.current &&
                              this.props.forwardedRef.current.getApi &&
                              this.props.forwardedRef.current.getApi()
                                .getDate &&
                              this.props.forwardedRef.current.getApi().getDate()
                                .toDateString &&
                              this.props.forwardedRef.current
                                .getApi()
                                .getDate()
                                .toDateString()

                            if (typeof dateString === 'string') {
                              this.setState({
                                date: `${dateString.slice(
                                  4,
                                  7,
                                )} ${dateString.slice(11)}`,
                              })
                            }
                          })
                        }
                      >
                        {language.task.menuSort.today}
                      </Button>
                    </Grid>
                    <Grid item>
                      <IconButton
                        className={classes.button}
                        onClick={() =>
                          Promise.resolve(
                            forwardedRef &&
                              forwardedRef.current &&
                              forwardedRef.current.getApi &&
                              forwardedRef.current.getApi().prev(),
                          ).then(() => {
                            const dateString =
                              this.props.forwardedRef &&
                              this.props.forwardedRef.current &&
                              this.props.forwardedRef.current.getApi &&
                              this.props.forwardedRef.current.getApi()
                                .getDate &&
                              this.props.forwardedRef.current.getApi().getDate()
                                .toDateString &&
                              this.props.forwardedRef.current
                                .getApi()
                                .getDate()
                                .toDateString()

                            if (typeof dateString === 'string') {
                              this.setState({
                                date: `${dateString.slice(
                                  4,
                                  7,
                                )} ${dateString.slice(11)}`,
                              })
                            }
                          })
                        }
                      >
                        <ArrowLeft fontSize="small" />
                      </IconButton>
                    </Grid>
                    <Grid item>
                      <IconButton
                        className={classes.button}
                        onClick={() =>
                          Promise.resolve(
                            forwardedRef &&
                              forwardedRef.current &&
                              forwardedRef.current.getApi &&
                              forwardedRef.current.getApi().next(),
                          ).then(() => {
                            const dateString =
                              this.props.forwardedRef &&
                              this.props.forwardedRef.current &&
                              this.props.forwardedRef.current.getApi &&
                              this.props.forwardedRef.current.getApi()
                                .getDate &&
                              this.props.forwardedRef.current.getApi().getDate()
                                .toDateString &&
                              this.props.forwardedRef.current
                                .getApi()
                                .getDate()
                                .toDateString()

                            if (typeof dateString === 'string') {
                              this.setState({
                                date: `${dateString.slice(
                                  4,
                                  7,
                                )} ${dateString.slice(11)}`,
                              })
                            }
                          })
                        }
                      >
                        <ArrowRight fontSize="small" />
                      </IconButton>
                    </Grid>
                    {/* <Grid item style={{ padding: 8 }}>
                      <span style={{ color: '#fff', lineHeight: '24px' }}>
                        {this.state.date}
                      </span>
                    </Grid> */}
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          </Grid>
          {viewSelected === 'calendar' ? null : (
            <Grid item>
              <SortMenu
                listFn={listFn}
                sort={sort}
                endpoint={endpoint}
                classes={classes}
                keys={sortableKeys}
                nonSortableKeys={nonSortableKeys}
              />
            </Grid>
          )}
          {viewSelected === 'list' ? null : (
            <Grid item>
              <Grid container>
                <Grid item>
                  <Button
                    size="small"
                    onClick={() =>
                      Promise.resolve(
                        forwardedRef &&
                          forwardedRef.current &&
                          forwardedRef.current.getApi &&
                          forwardedRef.current
                            .getApi()
                            .changeView('dayGridMonth'),
                      ).then(() => {
                        const dateString =
                          this.props.forwardedRef &&
                          this.props.forwardedRef.current &&
                          this.props.forwardedRef.current.getApi &&
                          this.props.forwardedRef.current.getApi().getDate &&
                          this.props.forwardedRef.current.getApi().getDate()
                            .toDateString &&
                          this.props.forwardedRef.current
                            .getApi()
                            .getDate()
                            .toDateString()

                        if (typeof dateString === 'string') {
                          this.setState({
                            date: `${dateString.slice(4, 7)} ${dateString.slice(
                              11,
                            )}`,
                          })
                        }
                      })
                    }
                    style={{ color: '#fff', minWidth: 0, padding: '6px 8px' }}
                  >
                    {language.task.menuSort.month}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    size="small"
                    onClick={() =>
                      Promise.resolve(
                        forwardedRef &&
                          forwardedRef.current &&
                          forwardedRef.current.getApi &&
                          forwardedRef.current
                            .getApi()
                            .changeView('timeGridWeek'),
                      ).then(() => {
                        const dateString =
                          this.props.forwardedRef &&
                          this.props.forwardedRef.current &&
                          this.props.forwardedRef.current.getApi &&
                          this.props.forwardedRef.current.getApi().getDate &&
                          this.props.forwardedRef.current.getApi().getDate()
                            .toDateString &&
                          this.props.forwardedRef.current
                            .getApi()
                            .getDate()
                            .toDateString()

                        if (typeof dateString === 'string') {
                          this.setState({
                            date: `${dateString.slice(4, 7)} ${dateString.slice(
                              11,
                            )}`,
                          })
                        }
                      })
                    }
                    style={{ color: '#fff', minWidth: 0, padding: '6px 8px' }}
                  >
                    {language.task.menuSort.week}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    size="small"
                    onClick={() =>
                      Promise.resolve(
                        forwardedRef &&
                          forwardedRef.current &&
                          forwardedRef.current.getApi &&
                          forwardedRef.current
                            .getApi()
                            .changeView('timeGridDay'),
                      ).then(() => {
                        const dateString =
                          this.props.forwardedRef &&
                          this.props.forwardedRef.current &&
                          this.props.forwardedRef.current.getApi &&
                          this.props.forwardedRef.current.getApi().getDate &&
                          this.props.forwardedRef.current.getApi().getDate()
                            .toDateString &&
                          this.props.forwardedRef.current
                            .getApi()
                            .getDate()
                            .toDateString()

                        if (typeof dateString === 'string') {
                          this.setState({
                            date: `${dateString.slice(4, 7)} ${dateString.slice(
                              11,
                            )}`,
                          })
                        }
                      })
                    }
                    style={{ color: '#fff', minWidth: 0, padding: '6px 8px' }}
                  >
                    {language.task.menuSort.day}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Paper>
    )

    if (viewSelected === 'calendar') {
      if (schedulerMounted) {
        return component
      }
      return null
    }

    return component
  }
}

const Sort = connect(
  state => ({
    viewSelected: state.tasks.viewSelected,
    schedulerMounted: state.tasks.schedulerMounted,
  }),
  null,
)(
  withStyles(theme => ({
    sort: {
      background: theme.palette.secondary.main,
      borderRadius: 25,
      textAlign: 'right',
      padding: theme.spacing.unit,
    },
    leftIcon: {
      marginRight: theme.spacing.unit,
    },
    button: {
      color: '#fff',
      [theme.breakpoints.down('xs')]: {
        padding: '6px 8px',
      },
      [theme.breakpoints.up('sm')]: {
        padding: '8px',
      },
    },
    // tag: {

    // },
  }))(SortComponent),
)

export default forwardRef((props, ref) => (
  <Sort forwardedRef={ref} {...props} />
))
